'use strict';

exports.__esModule = true;
exports.LineChart = undefined;

var _reactChartjs = require('react-chartjs-2');

var _index = require('../withChartTheme/index');

var LineChart = (0, _index.withChartTheme)(_reactChartjs.Line);
var LineChartDoc = void 0;

if (process.env.NODE_ENV !== 'production') {
  LineChartDoc = require('./doc')["default"](LineChart); // eslint-disable-line global-require
}

var LineChartWrapper = LineChartDoc || LineChart;
exports.LineChart = LineChartWrapper;